import React, { useMemo } from 'react';
import { IProductTexture } from '../../../../entities-generated/common/product-texture';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { BadgeType } from '../../../../framework/components/bwj-listing/entities';
import { isNotNullOrWhitespace } from '../../../../framework/utils';

interface ITextureVariantListItemProps {
  variant: IProductTexture;
  onClick: (variant: IProductTexture) => void;
  onGoToVendorSite: (variant: IProductTexture) => void;
}

export const TextureVariantListItem: React.FunctionComponent<ITextureVariantListItemProps> = (props) => {
  const { variant } = props;
  const img = useMemo(() => {
    if(isNotNullOrWhitespace(variant.swatchUrl)) { return variant.swatchUrl; }
    if(isNotNullOrWhitespace(variant.productImageUrls[0])) { return variant.productImageUrls[0]; }
    return 'https://byronwjones.com/images/logo-icon.jpg';
  }, [variant]);

  return (
    <BwjListing
      actions={[{
        icon: 'Globe',
        onClick: props.onGoToVendorSite,
      }]}
      heading={variant.name}
      badge={{
        type: BadgeType.Image,
        content: img,
      }}
      loadImage={true}
      data={variant}
      onClick={props.onClick}
    />
  );
};
